import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { DocumentCategoriesPanel } from './DocumentTypesScreen'
import Message from '../../components/Message'
import DocumentsHelpAlert from '../../components/files/DocumentsHelpAlert'
import { EntityNames } from '../../helpers/DataHelper'
import { AclAction, useUserContext } from '../../providers/UserContext'

function canReadEntity(user: ReturnType<typeof useUserContext>, entityName: EntityNames): boolean {
  return !user.isOrganization() || user.canDo(entityName, AclAction.read)
}

export default function DocumentsSettingsScreen() {
  const { t } = useTranslation()
  const user = useUserContext()
  const canReadDocuments = canReadEntity(user, EntityNames.MediaDocumentType)

  if (!canReadDocuments) {
    return <Message type="error" message={t('You are not allowed to access this screen')} />
  }

  return (
    <div>
      <Helmet>
        <title>{t('Documents')}</title>
      </Helmet>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          {t('Documents')}
        </Typography>
        <DocumentsHelpAlert variant="settings" />
      </Box>
      <DocumentCategoriesPanel />
    </div>
  )
}
